
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/information/about",
      function () {
        return require("private-next-pages/information/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/information/about"])
      });
    }
  